module.exports = __webpack_public_path__ + "img/68.89daf070.png";